import { Body, Controller, Post, Req } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import { DeheadingPeelingService } from "./deheading-peeling-service";
import { AllDeheadingpeelingResponse, DeheadingFilterReq, DeheadingPeelingRequest, DeheadingPeelingRequestDto, DeheadingPeelingResponseModel, ScopeGradeReq } from "@gtpl/shared-models/masters";
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { DeheadingPeelingRequests } from "./dto/deheading-peeling.request";
import { DeheadingPeelingDTO } from "./dto/deheading-peeling.dto";
import { CommonResponse } from "@gtpl/shared-models/production-management";

@ApiTags('deheading-peeling-chart')
@Controller('deheading-peeling-chart')
export class DeheadingPeelingController{
    constructor(
        private deheadingpeelingService:DeheadingPeelingService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){ }

    

    //    @Post('/updateRmCountPriceList')
    //    async updateRmCountPriceList(@Body() rmPriceListDTO:RmCountPriceListDto, @Req() request:Request): Promise<RmCountPriceListResponseModel> {
    //        try {
    //         return await this.rmCountPriceListService.createRmCountPriceList(rmPriceListDTO,true,request);
    //       } catch (error) {
    //            return this.applicationExceptionHandler.returnException(RmCountPriceListResponseModel, error);
    //       }
    //     }

        @Post('/saveDeheadingPeelingInfo')
        @ApiBody({ type: DeheadingPeelingRequestDto })
        async saveDeheadingPeelingInfo(@Body() data:DeheadingPeelingRequestDto): Promise<DeheadingPeelingResponseModel>{
           try{
            console.log(data,'data')
            return this.deheadingpeelingService.saveDeheadingPeelingInfoed(data);
           } catch(err){
            return this.applicationExceptionHandler.returnException(DeheadingPeelingResponseModel,err);
           }
        }

        @Post('/getDeheadingPeelingInfo')
        async getDeheadingPeelingInfo(@Body() data:DeheadingPeelingDTO): Promise<DeheadingPeelingResponseModel>{
           try{
            return this.deheadingpeelingService.getDeheadingPeelingInfo();
           } catch(err){
            return this.applicationExceptionHandler.returnException(DeheadingPeelingResponseModel,err);
           }
        }

        @Post('/getAllPeelingInfo')
        async getAllPeelingInfo(@Body() req: DeheadingFilterReq): Promise<CommonResponse>{
           try{
            return this.deheadingpeelingService.getAllPeelingInfo(req);
           } catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err);
           }
        }

        @Post('/getFoodTypes')
        async getFoodTypes(): Promise<CommonResponse>{
           try{
            return this.deheadingpeelingService.getFoodTypes();
           } catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err);
           }
        }

        @Post('/getValueAdd1')
        async getValueAdd1(): Promise<CommonResponse>{
           try{
            return this.deheadingpeelingService.getValueAdd1();
           } catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err);
           }
        }

        @Post('/getValueAdd2')
        async getValueAdd2(): Promise<CommonResponse>{
           try{
            return this.deheadingpeelingService.getValueAdd2();
           } catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err);
           }
        }

   @Post('/getScopeOfWorkDropdown')
   async getScopeOfWorkDropdown(): Promise<CommonResponse>{
      try{
      return this.deheadingpeelingService.getScopeOfWorkDropdown();
      } catch(err){
      return this.applicationExceptionHandler.returnException(CommonResponse,err);
      }
   }

   @Post('/getPellingRateAgainstScopeAndGrade')
   async getPellingRateAgainstScopeAndGrade(@Body() req:ScopeGradeReq): Promise<CommonResponse>{
      try{
      return this.deheadingpeelingService.getPellingRateAgainstScopeAndGrade(req);
      } catch(err){
      return this.applicationExceptionHandler.returnException(CommonResponse,err);
      }
   }
}